import React from "react";
import CoreInput from "../../../core/inputs/CoreInput";
import CoreAutoComplete from "../../../core/inputs/CoreAutoComplete";
import { Box, Grid } from "@mui/material";
import CoreButtonContainer from "../../../core/layouts/CoreButtonContainer";
import CoreButton from "../../../core/inputs/CoreButton";
import { newUserSchema } from "../../../formSchemas/userSchemas";
import { Formik } from "formik";
import CoreTypographyCaption from "../../../core/dataDisplay/CoreTypographyCaption";
import CoreContainedButton from "../../../core/inputs/CoreContainedButton";

export default function NewUser({
  roles,
  handleSubmit,
  errorMsg,
  signup = false,
}) {
  return (
    <Formik
      initialValues={
        signup
          ? {
              email: "",
              firstName: "",
              lastName: "",
              password: null,
              phone: null,
            }
          : {
              email: "",
              firstName: "",
              lastName: "",
              credit: "",
              role: null,
              password: null,
            }
      }
      validationSchema={newUserSchema}
      onSubmit={handleSubmit}
      enableReinitialize
    >
      {(formikProps) => (
        <Box style={{ paddingTop: 16 }}>
          <Grid container spacing={1}>
            <Grid item xs={6}>
              <CoreInput
                value={formikProps.values.firstName}
                onChange={formikProps.handleChange}
                id="firstName"
                label="Enter First Name"
                formikProps={formikProps}
              />
            </Grid>
            <Grid item xs={6}>
              <CoreInput
                value={formikProps.values.lastName}
                onChange={formikProps.handleChange}
                id="lastName"
                label="Enter Last Name"
                formikProps={formikProps}
              />
            </Grid>
            <Grid item xs={6}>
              <CoreInput
                value={formikProps.values.email}
                onChange={formikProps.handleChange}
                id="email"
                label="Enter Email"
                formikProps={formikProps}
              />
            </Grid>
            {signup && (
              <Grid item xs={6}>
                <CoreInput
                  value={formikProps.values.phone}
                  onChange={formikProps.handleChange}
                  id="phone"
                  label="Enter Phone"
                  type="number"
                  min={0}
                  step={1}
                  formikProps={formikProps}
                />
              </Grid>
            )}
            {!signup && (
              <Grid item xs={6}>
                <CoreInput
                  value={formikProps.values.credit}
                  onChange={formikProps.handleChange}
                  id="credit"
                  label="Enter Credit"
                  type="number"
                  min={0}
                  step={1}
                  formikProps={formikProps}
                />
              </Grid>
            )}
            {!signup && (
              <Grid item xs={6}>
                <CoreAutoComplete
                  id="role"
                  value={formikProps.values.role}
                  onChange={(id, value) => {
                    console.log("value", value, id);
                    formikProps.setFieldValue(id, value?.value);
                  }}
                  options={roles}
                  formikProps={formikProps}
                  label="Role"
                />
              </Grid>
            )}
            <Grid item xs={12}>
              <CoreInput
                id="password"
                value={formikProps.values.password}
                onChange={formikProps.handleChange}
                options={roles}
                formikProps={formikProps}
                label="Password"
                required={true}
              />
            </Grid>
          </Grid>
          {errorMsg && (
            <CoreTypographyCaption
              sx={{ textAlign: "center", p: 1 }}
              color="error"
            >
              {errorMsg}
            </CoreTypographyCaption>
          )}

          <Box>
            <CoreContainedButton
              fullWidth={true}
              onClick={formikProps.handleSubmit}
            >
              Submit
            </CoreContainedButton>
          </Box>
        </Box>
      )}
    </Formik>
  );
}
